export default __webpack_public_path__ + "static/stepa-85bd02cf9da72e704f38002a8a398289.png";